<ninety-menu data-cy="learn-support-menu_menu">
  @for (item of dataSource; track $index) {
    <span>
      @if (item.title) {
        <div class="menu-section-container">
          <span class="menu-section">{{ item.title }}</span>
        </div>
      }
      @for (cell of item.data; track $index) {
        <div class="menu-row">
          <ninety-menu-item-large
            attr.data-cy="learn-support-menu_item-{{ cell.label }}"
            [item]="cell"></ninety-menu-item-large>
        </div>
        @if (cell.divider) {
          <hr />
        }
      }
    </span>
  }
</ninety-menu>
